// ProjectTeamModal — the project team, opened from the register (v0.288.0).
//
// Brett: "where is the project team pages?" The team lived only on the
// project page (ProjectDetailScreen, with no report picked), so from a
// report's register there was no way to it. This box holds the same panel.
//
// onChange gets the team as it stands after each load / add / remove, so the
// register's item card Assignee list takes a new person straight away.
// Esc or a press outside closes; the panel's own picker catches Esc first.
//
// v0.300.0 — under the team, who holds a live link but is not on it
// (LinkHoldersPanel), matched against the team as the panel last read it.
// onLinksChange is called after links there are turned off.
//
// v0.316.0 — addTo ('client' | 'trade'): opened from that group on the
// register's strip; the panel opens its contacts list for that chat.

// v0.339.0 — Brett: "Location shows nothing. Do it properly." The team is the
// REPORT's: this box edits the open report's team (reportId) and its links.
// Without a report there is no team to show, so the register offers no box.

import React, { useCallback, useEffect, useState } from 'react';
import { theme } from '../theme';
import ProjectContactsPanel from './ProjectContactsPanel';
import LinkHoldersPanel from './LinkHoldersPanel';

export default function ProjectTeamModal({ projectId, reportId, addTo = null, onChange, onLinksChange, onClose }) {
  // null until the panel has read the team: "not looked yet" is not "nobody".
  const [team, setTeam] = useState(null);
  const onTeam = useCallback((list) => {
    setTeam(list);
    if (onChange) onChange(list);
  }, [onChange]);
  useEffect(() => {
    const onKey = (e) => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [onClose]);

  return (
    <div
      data-part="team-box"
      onClick={onClose}
      style={{
        // v0.303.0 — Brett, dark mode: "too hard to read this". The dimmer was
        // the dark surface's own navy at half strength, so the box and the
        // register behind it were one colour. Black dims either theme.
        position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.6)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        zIndex: 100, padding: 16,
      }}
    >
      <div
        role="dialog"
        aria-modal="true"
        aria-label="Report team"
        onClick={(e) => e.stopPropagation()}
        style={{
          background: theme.surface, width: 760, maxWidth: '100%', maxHeight: '80vh',
          borderRadius: 10, padding: 18, boxSizing: 'border-box',
          border: '1px solid var(--border-strong)', boxShadow: 'var(--shadow-3)',
          display: 'flex', flexDirection: 'column',
        }}
      >
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 8 }}>
          <h3 style={{ margin: 0, fontSize: 17, fontWeight: 800 }}>Report team</h3>
          <button
            type="button"
            onClick={onClose}
            aria-label="Close"
            style={{
              border: 0, background: 'transparent', cursor: 'pointer',
              fontSize: 18, color: theme.textLight, lineHeight: 1,
            }}
          >×</button>
        </div>
        <div style={{ overflowY: 'auto', minHeight: 0 }}>
          <ProjectContactsPanel reportId={reportId} addTo={addTo} onChange={onTeam} bare />
          <LinkHoldersPanel projectId={projectId} reportId={reportId} team={team} onLinksChange={onLinksChange} />
        </div>
      </div>
    </div>
  );
}
